import { createAction } from 'redux-actions';
import moment from 'moment';
import { ActionTypes as actions } from '../actionTypes/actionTypes';

moment.locale('ja');

export const clearState = createAction(actions.CLEAR_STATE);
